import { Typography } from "@material-ui/core";
import React from "react";
import { trackPromise } from "react-promise-tracker";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import axios from '../../../axios/AxiosInterceptors';
import { onError, onSuccess } from "../../../store/actions/popupActions";
import useStyles from "../../../Styles";
import MeterAccountComponent from "./MeterAccountComponent";

const CreateMeterAccount = (props) => {

    const classes = useStyles(props);
    const history = useHistory();
    const dispatch = useDispatch();

    const saveMeterAccount = async (accountId, meterAccountId, meterAccount) => {
        let meter = { ...meterAccount };
        meter.accountId = parseInt(accountId);
        await trackPromise(axios.post("/powermeter/v1/account/" + accountId + "/meter", JSON.stringify(meter)).then(response => {
            dispatch(onSuccess("Successfully saved meter account " + meter.meterName));
            history.push("/meter-reading/account/" + accountId + "/meter-account");
        })).catch(error => {
            dispatch(onError(error));
        })
    }

    return (
        <main className={classes.layout}>
            <Typography variant="h4" align="center">Create Meter Account</Typography>
            <MeterAccountComponent saveMeterAccount={saveMeterAccount} />
        </main>
    )


}

export default CreateMeterAccount;